export const FETCH_PLATFORM_URL = `${process.env.REACT_APP_API_URL}/platforms`;
export const CREATE_PLATFORM_URL = `${process.env.REACT_APP_API_URL}/platforms`;
